<div class="dx-navigator__header">

  <!-- Область под иконку Home (она статичная) -->
  <div class="dx-navigator__header-part dx-navigator__header-part--toolbar" *ngIf="showHomeBtn && homeBtnIcon">
    <a class="dx-navigator__header-logo" title="Вернуться на домашнюю страницу" (click)="onHomeClick()">
      <img [src]="homeBtnIcon" alt="">
    </a>
  </div>

  <!-- Кнопка прокрутки списка влево (появляется если его длина превышает заданный порог) -->
  <div class="dx-navigator__header-part dx-navigator__header-part--toolbar" *ngIf="showCarousel">
    <a class="dx-header-btn dx-navigator__header-btn"
       [ngClass]="{'dx-header-btn--active': canPrev(), 'dx-header-btn--disabled': !canPrev()}"
       title="Показать предыдущие"
       (click)="onGoPrev()">
      <img class="dx-navigator__header-arrow" [src]="prevBtnIcon">
    </a>
  </div>

  <!-- Список родительскийх элементов навигационного меню -->
  <div class="dx-navigator__header-part dx-navigator__header-part--menu">
    <ul class="dx-head-navigation-menu">
      <ng-container *ngFor="let item of displayedItems">
        <!-- Изменение механизмов отображения элемнтов верхнего меню в зависимости от глубины навигационного дерва. -->
        <!-- Почему не в завсимости от глубины ветви для каждого отделно пункта? -->
        <!-- Да потому что все должно отображаться единообразно. -->
        <ng-container [ngSwitch]="menuTree.depth">
          <!-- Для единичной глубиный отображаем пункты меню просто в виде текствых лейблов. -->
          <ng-container *ngSwitchCase="1">
            <li class="dx-head-navigation-menu__item" (click)="onMenuItemClick(item)">
              <a class="dx-head-navigation-menu__link"
                 [title]="item.hint"
                 [ngClass]="{'dx-head-navigation-menu__link--active': isActiveItem(item)}">
                {{item.title}}
              </a>
            </li>
          </ng-container>

          <!-- Для меню из двух уровней, отображение в виде раскрываемого контейнера -->
          <!-- с выпадающей панелью под линейный список элементов второго уровня. -->
          <ng-container *ngSwitchCase="2">
            <dx-head-dropdown-panel [menuNode]="item"></dx-head-dropdown-panel>
          </ng-container>

          <!-- По умолчанию рассматривается произвольная глубина. -->
          <!-- Отображать видимо в виде раскрываемых контейнеров с выпадающей панелью под дерево -->
          <ng-container *ngSwitchDefault>
            <dx-head-dropdown-tree [menuNode]="item"></dx-head-dropdown-tree>
          </ng-container>

        </ng-container>
      </ng-container>
    </ul>

  </div>

  <!-- Кнопка прокрутки списка вправо (появляется если его длина превышает заданный порог) -->
  <div class="dx-navigator__header-part dx-navigator__header-part--toolbar" *ngIf="showCarousel">
    <a class="dx-header-btn dx-navigator__header-btn"
       [ngClass]="{'dx-header-btn--active': canNext(), 'dx-header-btn--disabled': !canNext()}"
       title="Показать следующие"
       (click)="onGoNext()">
      <img class="dx-navigator__header-arrow" [src]="nextBtnIcon">
    </a>
  </div>

</div>

